<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 头部统计 -->
    <div class="statistical-data">
      <div class="f16 color1989fa fw-600 mgt-20 mgb-10">统计</div>
      <el-form ref="form" :inline="true" :model="form" label-width="80px">
        <el-form-item label="所属场景" v-if="sceneArr.length > 1">
          <el-select
            v-model="form.scene"
            placeholder="全部"
            clearable
            filterable
            @clear="clearSelect"
            @change="changeSelect"
          >
            <el-option
              v-for="(v, i) in sceneArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型" v-if="fuwuduan.length > 1">
          <el-select
            v-model="form.fuwu"
            placeholder="全部"
            clearable
            filterable
            @clear="clearSelect"
            @change="changeSelect"
          >
            <el-option
              v-for="(v, i) in fuwuduan"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="statistics">
        <div class="box stat-card equipment-card">
          <div class="stat-card-header">
            <div>
              <div class="stat-card-title">设备总数</div>
              <div class="stat-card-value equipment-value">{{ shebeiForm.countNum ? shebeiForm.countNum : 0 }}台</div>
            </div>
            <div class="stat-card-icon equipment-icon"><i class="el-icon-box"></i></div>
          </div>
          <div class="stat-card-body">
            <div class="stat-card-row">在线设备<span>{{ shebeiForm.onlineNum ? shebeiForm.onlineNum : 0 }}台</span></div>
            <div class="stat-card-row">离线设备<span>{{ shebeiForm.offlineNum ? shebeiForm.offlineNum : 0 }}台</span></div>
          </div>
        </div>

        <div class="box stat-card card-card">
          <div class="stat-card-header">
            <div>
              <div class="stat-card-title">水卡总数</div>
              <div class="stat-card-value card-value">{{ userForm.total ? userForm.total : 0 }}张</div>
            </div>
            <div class="stat-card-icon card-icon"><i class="el-icon-bank-card"></i></div>
          </div>
          <div class="stat-card-body">
            <div class="stat-card-row">电子水卡<span>{{ userForm.cardWaterNum ? userForm.cardWaterNum : 0 }}张</span></div>
            <div class="stat-card-row">实物水卡<span>{{ userForm.cardEntityNum ? userForm.cardEntityNum : 0 }}张</span></div>
          </div>
          <div class="cardHint">温馨提示:水卡统计未区分所属场景。</div>
          <!-- <el-button class="detailsBtn" @click="cardVisible = true">详情</el-button> -->
        </div>

        <div class="box stat-card recharge-card">
          <div class="stat-card-header">
            <div>
              <div class="stat-card-title">充值金额</div>
              <div class="stat-card-value recharge-value">{{ orderForm.rechargeMoneyAll }}元</div>
            </div>
            <div class="stat-card-icon recharge-icon"><i class="el-icon-wallet"></i></div>
          </div>
          <div class="stat-card-body">
            <div class="stat-card-row">赠送金额<span>{{ orderForm.rechargeSendMoneyAll }}元</span></div>
            <div class="stat-card-row">实付金额<span>{{ orderForm.rechargePayMoneyAll }}元</span></div>
          </div>
          <el-button class="detailsBtn" @click="topVisible = true">详情</el-button>
        </div>

        <div class="box stat-card order-card">
          <div class="stat-card-header">
            <div>
              <div class="stat-card-title">消费订单</div>
              <div class="stat-card-value order-value">{{ orderForm.orderNumAll }}笔</div>
            </div>
            <div class="stat-card-icon order-icon"><i class="el-icon-tickets"></i></div>
          </div>
          <div class="stat-card-body">
            <div class="stat-card-row">今日订单<span>{{ orderForm.orderNumDay }}笔</span></div>
            <div class="stat-card-row">昨日订单<span>{{ orderForm.orderNumYestDay }}笔</span></div>
            <div class="stat-card-row">本月订单<span>{{ orderForm.orderNumMonth }}笔</span></div>
          </div>
        </div>

        <div class="box stat-card consume-card">
          <div class="stat-card-header">
            <div>
              <div class="stat-card-title">消费金额</div>
              <div class="stat-card-value consume-value">{{ orderForm.orderPriceAll }}元</div>
            </div>
            <div class="stat-card-icon consume-icon"><i class="el-icon-money"></i></div>
          </div>
          <div class="stat-card-body">
            <div class="stat-card-row">今日消费<span>{{ orderForm.orderPriceDay }}元</span></div>
            <div class="stat-card-row">昨日消费<span>{{ orderForm.orderPriceYestDay }}元</span></div>
            <div class="stat-card-row">本月消费<span>{{ orderForm.orderPriceMonth }}元</span></div>
          </div>
          <el-button class="detailsBtn" @click="orderVisible = true">详情</el-button>
        </div>

        <!-- <div class="box">
          <div class="f22 center isHaveDetail">
            <div>总收益</div>
            <el-button class="detailsBtn" @click="handleYieldDetail"
              >详情</el-button
            >
            <div class="color052173">
              {{ orderForm.incomeAll ? orderForm.incomeAll : 0 }}元
            </div>
          </div>
          <div class="f18 flex jcsb aic mgt-20">
            今日收益
            <span class="color052173"
              >{{ orderForm.incomeDay ? orderForm.incomeDay : 0 }}元</span
            >
          </div>
          <div class="f18 flex jcsb aic mgt-20">
            昨日收益
            <span class="color052173"
              >{{
                orderForm.incomeYestDay ? orderForm.incomeYestDay : 0
              }}元</span
            >
          </div>
          <div class="f18 flex jcsb aic mgt-20">
            本月收益
            <span class="color052173"
              >{{ orderForm.incomeMonth ? orderForm.incomeMonth : 0 }}元</span
            >
          </div>
        </div> -->
        <!-- === -->
      </div>
    </div>

    <!-- 设备总数总数弹框 -->
    <el-dialog
      title="设备总数"
      :visible.sync="shebeiVisible"
      width="30%"
      center
      top="35vh"
    >
      <el-descriptions border column="4" title="全部">
        <el-descriptions-item label="设备总数">{{
          cardDetail.total
        }}</el-descriptions-item>
        <el-descriptions-item label="商用净水机">{{
          cardDetail.cardEntityNum
        }}</el-descriptions-item>
        <el-descriptions-item label="家用净水机">{{
          cardDetail.cardWaterNum
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="商用净水机">
        <el-descriptions-item label="已启用">{{
          cardDetail.timeEntityNum
        }}</el-descriptions-item>
        <el-descriptions-item label="待启用">{{
          cardDetail.entityNum
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="家用净水机">
        <el-descriptions-item label="已启用">{{
          cardDetail.timeWaterNum
        }}</el-descriptions-item>
        <el-descriptions-item label="待启用">{{
          cardDetail.waterNum
        }}</el-descriptions-item>
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button @click="shebeiVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 水卡总数弹框 -->
    <el-dialog
      title="水卡总数"
      :visible.sync="cardVisible"
      width="30%"
      center
      top="35vh"
    >
      <el-descriptions border column="4" title="全部">
        <el-descriptions-item label="水卡总数">{{
          cardDetail.total
        }}</el-descriptions-item>
        <el-descriptions-item label="实物卡">{{
          cardDetail.cardEntityNum
        }}</el-descriptions-item>
        <el-descriptions-item label="电子卡">{{
          cardDetail.cardWaterNum
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="实物卡">
        <el-descriptions-item label="时效实物卡">{{
          cardDetail.timeEntityNum
        }}</el-descriptions-item>
        <el-descriptions-item label="普通实物卡">{{
          cardDetail.entityNum
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="电子卡">
        <el-descriptions-item label="时效电子卡">{{
          cardDetail.timeWaterNum
        }}</el-descriptions-item>
        <el-descriptions-item label="普通电子卡">{{
          cardDetail.waterNum
        }}</el-descriptions-item>
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cardVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 弹框 -->
    <el-dialog
      title="消费金额"
      :visible.sync="orderVisible"
      width="30%"
      center
      top="35vh"
    >
      <el-descriptions border column="4" title="全部">
        <el-descriptions-item label="总金额">{{
          orderForm.orderPriceAll
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.orderSendPriceAll
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.orderPayPriceAll
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{
          orderForm.orderRefundPriceAll
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="今日">
        <el-descriptions-item label="总金额">{{
          orderForm.orderPriceDay
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.orderSendPriceDay
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.orderPayPriceDay
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{
          orderForm.orderRefundPriceDay
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="昨日">
        <el-descriptions-item label="总金额">{{
          orderForm.orderPriceYestDay
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.orderSendPriceYestDay
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.orderPayPriceYestDay
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{
          orderForm.orderRefundPriceYestDay
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border column="4" title="本月">
        <el-descriptions-item label="总金额">{{
          orderForm.orderPriceMonth
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.orderSendPriceMonth
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.orderPayPriceMonth
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{
          orderForm.orderRefundPriceMonth
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="充值金额"
      :visible.sync="topVisible"
      width="30%"
      center
      top="35vh"
    >
      <el-descriptions border title="全部">
        <el-descriptions-item label="总金额">{{
          orderForm.rechargeMoneyAll
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.rechargeSendMoneyAll
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.rechargePayMoneyAll
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions border title="已消费">
        <el-descriptions-item label="总金额">{{
          orderForm.rechargeMoneyUse
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.rechargeSendMoneyUse
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.rechargePayMoneyUse
        }}</el-descriptions-item> </el-descriptions
      ><el-descriptions border title="待消费">
        <el-descriptions-item label="总金额">{{
          orderForm.rechargeMoneySurplus
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{
          orderForm.rechargeSendMoneySurplus
        }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">{{
          orderForm.rechargePayMoneySurplus
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="topVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 收益统计弹框 -->
    <el-dialog
      title="收益统计"
      :visible.sync="yieldVisible"
      width="30%"
      top="35vh"
      center
      :close-on-click-modal="false"
    >
      <!--  -->
      <div class="yieldTop">
        <div class="flex">
          <div
            :class="yieldSelectActive == v.id ? 'selectActive' : 'select'"
            v-for="v in yieldSelectArr"
            :key="v.id"
            @click="yieledSelectBtn(v)"
          >
            {{ v.name }}
          </div>
        </div>

        <div v-if="yieldSelectActive == 1">
          <el-date-picker
            :clearable="false"
            @change="monthChange"
            v-model="yieldStatTime_month"
            format="yyyy-MM"
            type="month"
            placeholder="请选择日期"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </div>

        <div v-if="yieldSelectActive == 2">
          <el-date-picker
            :clearable="false"
            @change="yearChange"
            v-model="yieldStatTime_year"
            format=" yyyy"
            type="year"
            placeholder="请选择日期"
            value-format="yyyy"
          >
          </el-date-picker>
        </div>
      </div>
      <!--  -->
      <div class="mgt-10 mgb-5">总收益（元）：{{ yieldStat.toFixed(2) }}</div>
      <!-- 表格 -->
      <div class="yieldTable">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column prop="day" label="时间"> </el-table-column>
          <el-table-column prop="wxPrice" label="微信订单收益">
          </el-table-column>
          <el-table-column prop="rechargeReal" label="水卡充值收益">
          </el-table-column>
          <el-table-column prop="allMoney" label="总收益"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yieldVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="设备统计"
      :visible.sync="equipmentVisible"
      width="80%"
      center
      :close-on-click-modal="false"
      top="20vh"
    >
      <!-- 查询 -->
      <div class="mgb-10 ">
        <el-form
          :inline="true"
          ref="shebeiChaForm"
          :model="shebeiChaForm"
          label-width="80px"
        >
          <el-form-item label="设备型号">
            <el-select
              v-model="shebeiChaForm.model"
              placeholder="全部"
              clearable
            >
              <el-option
                v-for="v in typeListArr"
                :key="v.id"
                :label="v.equipmentVersion"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input
              v-model="shebeiChaForm.num"
              placeholder="请输入设备编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="铺设模式">
            <el-select
              clearable
              v-model="shebeiChaForm.typeName"
              placeholder="全部"
            >
              <el-option label="购买" value="1"></el-option>
              <el-option label="租赁" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-form
          :inline="true"
          ref="shebeiChaForm"
          :model="shebeiChaForm"
          label-width="80px"
        >
          <el-form-item label="铺设地址">
            <el-input
              v-model="shebeiChaForm.address"
              placeholder="请输入地址"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <div class="flex">
              <el-date-picker
                v-model="shebeiChaForm.startTime"
                format="yyyy-MM-dd"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              至
              <el-date-picker
                v-model="shebeiChaForm.endTime"
                :picker-options="pickerOptionsEnd9"
                format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEquipmentList()"
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 导出 -->
      <div class="mgb-10 flex aic jcsb">
        <el-form ref="exportForm" :model="exportForm" label-width="80px">
          <el-form-item label="创建时间">
            <div class="flex">
              <el-date-picker
                v-model="exportForm.startTime"
                format="yyyy-MM-dd"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              至
              <el-date-picker
                :disabled="!exportForm.startTime"
                v-model="exportForm.endTime"
                :picker-options="pickerOptionsEnd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button class="mgl-10" @click="equipmentExportBtn"
                >导出</el-button
              >
            </div>
          </el-form-item>
          <div class="color0272f8">注：导出时间范围只能为31天以内。</div>
        </el-form>
      </div>
      <el-table :data="equipmentTableData" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="equipmentVersion" label="设备型号">
        </el-table-column>
        <el-table-column prop="equipmentNum" label="设备编号">
        </el-table-column>
        <el-table-column prop="companyName" label="设备归属"> </el-table-column>
        <el-table-column prop="typeName" label="铺设模式"> </el-table-column
        ><el-table-column prop="equipmentPlace" label="铺设地址">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <!-- <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination> -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="equipmentVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>
    <!-- 折线和表格 -->
    <div class="tableSelect">
      <div
        :class="tableActive == v.id ? 'tableActive' : 'table'"
        v-for="(v, i) in tableSelect"
        :key="i"
        @click="changeTable(v)"
      >
        {{ v.title }}
      </div>
    </div>
    <!-- ===== -->
    <div class="flex aic jcsb">
      <div class="typeSelect">
        <div
          :class="typeActive == v.id ? 'typeActive' : 'type'"
          v-for="v in typeSelect"
          :key="v.id"
          @click="typeChange(v)"
        >
          {{ v.title }}
        </div>
      </div>
      <div class="dateSelect">
        <div
          :class="dateActive == v.id ? 'dateActive' : 'date'"
          v-for="v in dateSelect"
          :key="v.id"
          @click="dateChange(v)"
        >
          {{ v.title }}
        </div>

        <el-popover
          v-model="moreDisplay"
          placement="bottom"
          width="400"
          trigger="click"
        >
          <div class="flex aic">
            <el-date-picker
              v-model="moreStartTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              :disabled="!moreStartTime"
              v-model="moreEndTime"
              :picker-options="pickerOptionsEnd15"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-button type="primary" class="mgl-10" @click="moreTimeSure"
              >确定</el-button
            >
          </div>
          <div
            slot="reference"
            @click="dateActive = 3"
            :class="dateActive == 3 ? 'dateActive' : 'date'"
          >
            {{ moreName }}
          </div>
        </el-popover>
        <!-- === -->
      </div>
    </div>
    <!-- 折线 -->
    <div v-if="tableActive == 1" key="chart" id="main" ref="chart"></div>

    <!-- 表格 -->
    <div class="mgt-20" v-if="tableActive == 2 && typeActive === 1">
      <el-table
        max-height="350"
        :data="statTable"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="day" label="日期"> </el-table-column>
        <el-table-column prop="name" label="消费订单笔数">
          <template slot-scope="scope">
            <span v-text="scope.row.orderNum"></span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="消费订单金额">
          <template slot-scope="scope">
            <span v-text="scope.row.orderPrice"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 表格 -->
    <div class="mgt-20" v-if="tableActive == 2 && typeActive == 2">
      <el-table
        max-height="350"
        :data="statTableTop"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="day" label="日期"> </el-table-column>
        <el-table-column prop="name" label="充值订单笔数">
          <template slot-scope="scope">
            <span
              v-text="scope.row.rechargeNum ? scope.row.rechargeNum : 0"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="充值订单金额(实付/赠送)">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.all ||
                scope.row.rechargeGive ||
                scope.row.rechargeReal
                  ? scope.row.all +
                    '(' +
                    scope.row.rechargeReal +
                    '/' +
                    scope.row.rechargeGive +
                    ')'
                  : '0.00(0/0)'
              "
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 权限 -->
    <!-- <div
      class="roledLook"
      v-if="roleId !== 1 && roleId !== 23 && roleId !== 20 && roleId !== 18"
    >
      <div class="stat">
        <div class="statNum mgt-60">
          <div class="f28 flex fdc  aic">
            <div>设备总数</div>
            <div class="color052173 mgt-20">
              {{ shebeiForm.countNum ? shebeiForm.countNum : 0 }}台
            </div>
          </div>
          <div class="f20 flex jcsb aic mgt-100">
            启用设备<span class="color052173"
              >{{ shebeiForm.usingNum ? shebeiForm.usingNum : 0 }}台</span
            >
          </div>
          <div class="f20 flex jcsb aic mgt-100">
            待启用设备<span class="color052173"
              >{{ shebeiForm.notUsingNum ? shebeiForm.notUsingNum : 0 }}台</span
            >
          </div>
        </div>
      </div>
      <div class="stat">
        <div class="statNum mgt-60">
          <div class="f28 flex fdc  aic ">
            <div>水卡总数</div>
            <div class="color052173 mgt-20">
              {{ userForm.total ? userForm.total : 0 }}张
            </div>
          </div>
          <div class="f20 flex jcsb aic mgt-100">
            电子水卡<span class="color052173"
              >{{ userForm.waterNum ? userForm.waterNum : 0 }}张</span
            >
          </div>
          <div class="f20 flex jcsb aic mgt-100">
            实物水卡<span class="color052173"
              >{{ userForm.entityNum ? userForm.entityNum : 0 }}张</span
            >
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import * as echarts from "echarts";
import store from "../../store";
import { chartTheme } from "../../utils/theme"; // 图表日/夜主题
// import { fuwuduan } from "../../utils/fuwuduan";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },

  data() {
    return {
      fuwuduan: [],
      moreDisplay: false,
      moreStartTime: "",
      moreEndTime: "",
      moreName: "更多",
      pickerOptionsEnd15: {
        disabledDate: (date) => {
          const start = new Date(this.moreStartTime); // 开始日期
          const end = new Date(date); // 当前选择的结束日期

          // 设置开始日期的最小日期
          const minDate = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate()
          );

          return (
            end < minDate ||
            end >
              new Date(
                start.getFullYear(),
                start.getMonth(),
                start.getDate() + 30
              )
          );
        },
      },
      orderForm: {
        orderPriceAll: 0,
        orderPriceDay: 0,
        orderPriceMonth: 0,
        orderNumAll: 0,
        orderNumDay: 0,
        orderNumMonth: 0,
        rechargeMoneyAll: 0,
        rechargeMoneyUse: 0,
        rechargeMoneySurplus: 0,
        orderNumYestDay: 0,
        orderPriceYestDay: 0,
        incomeAll: 0,
        incomeDay: 0,
        incomeYestDay: 0,
        incomeMonth: 0,
        orderSendPriceYestDay: 0,
        orderPayPriceYestDay: 0,
        orderRefundPriceAll: 0,
        orderRefundPriceDay: 0,
        orderRefundPriceMonth: 0,
        orderRefundPriceYestDay: 0,
        // 收益
        yieldAll: 0,
        yieldToday: 0,
        yieldYesterday: 0,
      }, //关于订单的表单
      userForm: {
        total: 0,
        entityNum: 0,
        waterNum: 0,
      }, //客户表单
      shebeiForm: {
        countNum: 0,
        notUsingNum: 0,
        usingNum: 0,
      }, //设备总计
      dateSelect: [
        { id: 1, title: "近7日" },
        { id: 2, title: "近30日" },
        // { id: 3, title: "更多" },
      ],
      dateActive: 1,
      typeSelect: [
        { id: 1, title: "订单" },
        { id: 2, title: "充值" },
        // { id: 3, title: "收益" },
      ],
      typeActive: 1,

      tableSelect: [
        { id: 1, title: "趋势分析" },
        { id: 2, title: "列表分析" },
        // { id: 3, title: "收益" },
      ],
      tableActive: 1,
      statTable: [],
      statTableTop: [],
      date: [],
      orderNum: [],
      orderMoney: [],
      // titleName: ["订单笔数（笔）", "订单金额（元）"],
      // titleName: ["订单笔数（笔）", "订单金额（元）"],
      // numName: "订单笔数（笔）",
      // moneyName: "订单金额（元）",
      titleName: ["消费订单（笔）", "消费金额（元）"],
      numName: "消费订单（笔）",
      moneyName: "消费金额（元）",
      myChart: null,
      roleId: null,
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: { guishu: "" },
      orderVisible: false,
      topVisible: false,
      guishuqiye: [],
      yieldVisible: false,
      yieldSelectArr: [
        { id: 1, name: "日数据" },
        { id: 2, name: "月数据" },
      ],
      yieldSelectActive: 1,
      yieldStatTime_month: new Date().toISOString().slice(0, 7),
      yieldStatTime_year: new Date().getFullYear().toString(),
      tableData: [],
      yieldStat: 0,
      equipmentVisible: false,
      equipmentTableData: [],
      exportForm: {
        startTime: "",
        endTime: "",
      },

      shebeiChaForm: {},

      pickerOptionsEnd: {
        disabledDate: (date) => {
          const start = new Date(this.exportForm.startTime); // 开始日期
          const end = new Date(date); // 当前选择的结束日期

          // 设置开始日期的最小日期
          const minDate = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate()
          );

          return (
            end < minDate ||
            end >
              new Date(
                start.getFullYear(),
                start.getMonth(),
                start.getDate() + 30
              )
          );
        },
      },
      pickerOptionsEnd9: {
        disabledDate: (time) => {
          let beginDateVal = this.shebeiChaForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      typeListArr: [],
      lebel1: "",
      lebel2: "",
      cardVisible: false,
      cardDetail: {},
      shebeiVisible: false,
      shebeiDetail: {},
      sceneArr: [
        {
          name: "景区场景",
          id: 1,
        },
        {
          name: "校园场景",
          id: 2,
        },
        {
          name: "社区场景",
          id: 3,
        },
      ],
    };
  },
  watch: {
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    },
    "shebeiChaForm.startTime"() {
      if (this.shebeiChaForm.startTime == null) {
        this.fshebeiChaFormorm.endTime = null;
      }
    },
    moreStartTime() {
      if (this.moreStartTime == null) {
        this.moreEndTime = null;
      }
    },
  },
  created() {
    this.getScene();
    this.getServer();
    this.getOrder();
    // this.getUser();
    this.getshabei();
    this.aboutSevenOrder();
    // this.waterCard();
    this.getROLE();
    // this.getGuishu();
    // this.getTypeList();
    this.getCardNum();
  },
  mounted() {
    this.getEcharts();
    this.aboutSevenOrder();
    // 图表随内容区尺寸自适应（观察组件根节点，避免 #main 被条件渲染销毁后 RO 失效）
    this._resizeChart = () => this.myChart && this.myChart.resize();
    if (window.ResizeObserver) {
      this._chartRO = new ResizeObserver(this._resizeChart);
      this._chartRO.observe(this.$el);
    }
    window.addEventListener("resize", this._resizeChart);
    // 切日/夜主题时按新配色重建（init 的主题参数实例化后不可变）；getEcharts 用组件状态重画
    this._onThemeChange = () => {
      if (this.myChart) {
        this.myChart.dispose();
        this.myChart = null;
      }
      this.getEcharts();
    };
    window.addEventListener("themechange", this._onThemeChange);
  },

  methods: {
    getScene() {
      var token = store.getters.get_token;
      if (token) {
        this.sceneArr = [];
        token.sceneInfo.forEach((v) => {
          if (Number(v) == 1) {
            this.sceneArr.push({ name: "景区场景", id: Number(v) });
          } else if (Number(v) == 2) {
            this.sceneArr.push({ name: "校园场景", id: Number(v) });
          } else if (Number(v) == 3) {
            this.sceneArr.push({ name: "社区场景", id: Number(v) });
          }
        });
      }
    },
    // 字典表
    getShebeiType() {
      this.$api.dict.list({ dictName: "服务管理" }).then((res) => {
        console.log(res, "字典表");

        if (res.code === 200) {
          this.fuwuduan = [];

          res.data.forEach((v) => {
            if (v.dictPid !== 0) {
              this.fuwuduan.push({
                name: v.dictName,
                id: v.dictValue,
              });
            }
          });
        }
      });
    },
    getServer() {
      this.$api.home.serverHttp().then((res) => {
        if (res.code === 200) {
          let serverArr = res.data;

          // 等待 getFuwu 函数的结果，并更新 serverArr
          this.getFuwu(serverArr).then((updatedServerArr) => {
            this.fuwuduan = updatedServerArr;
          });
        }
      });
    },
    getFuwu(n) {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$api.dict
          .list({ dictName: "服务管理" })
          .then((res) => {
            if (res.code === 200) {
              let arr = n.map((itemA) => {
                // 在 B 数组中查找匹配的项
                let matchedItemB = res.data.find(
                  (itemB) => itemB.dictValue === itemA.id
                );

                // 如果找到匹配项，更新 itemA 的 name 字段
                if (matchedItemB) {
                  itemA.name = matchedItemB.dictName;
                }

                return itemA;
              });

              // 解析 Promise，返回更新后的数组
              resolve(arr);
            } else {
              // 如果请求失败，拒绝 Promise
              reject(new Error("Failed to fetch dictionary list."));
            }
          })
          .catch((error) => {
            // 捕获并处理任何网络错误或其他异常
            reject(error);
          });
      });
    },
    // 改变table
    changeTable(v) {
      this.tableActive = v.id;
      if (
        this.typeActive == 2 &&
        this.dateActive == 1 &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutSevenTop();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 2 &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutMonthTop();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 1 &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutSevenOrder();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 2 &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutMonthOrder();
      } else if (
        this.typeActive == 3 &&
        this.dateActive == 1 &&
        this.tableActive == 1
      ) {
        this.titleName = ["收益金额（元）"];
        // this.numName = "订单笔数（笔）";
        this.moneyName = "收益金额（元）";
        this.aboutSevenMoney();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutMoreOrder();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutMoreTop();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenTopTable();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutMonthTopTable();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenOrderTable();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutMonthOrderTable();
      } else if (
        this.typeActive == 3 &&
        this.dateActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenMoney();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 2
      ) {
        this.aboutMoreOrderTable();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 2
      ) {
        this.aboutMoreTopTable();
      }
    },
    // 更多日期时间选择确定按钮
    moreTimeSure() {
      if (!this.moreStartTime) {
        handleAlert("请至少选择起始时间", "warning");
        return;
      }
      if (this.moreStartTime && !this.moreEndTime) {
        this.moreName =
          this.moreStartTime +
          "-" +
          this.calculateFutureDate(this.moreStartTime, 31);
      } else if (this.moreStartTime && this.moreEndTime) {
        this.moreName = this.moreStartTime + "-" + this.moreEndTime;
      } else {
        this.moreName = "更多";
      }
      this.moreDisplay = false;
      if (this.typeActive === 1 && this.tableActive == 1) {
        this.aboutMoreOrder();
      } else if (this.typeActive === 2 && this.tableActive == 1) {
        this.aboutMoreTop();
      } else if (this.typeActive === 1 && this.tableActive == 2) {
        this.aboutMoreOrderTable();
      } else if (this.typeActive === 2 && this.tableActive == 2) {
        this.aboutMoreTopTable();
      }
    },

    // 时间查订单
    aboutMoreOrder() {
      this.$api.home
        .forTime({
          companyId: this.form.guishu ? this.form.guishu : null,
          startDay: this.moreStartTime,
          endDay: this.moreEndTime
            ? this.moreEndTime
            : this.calculateFutureDate(this.moreStartTime, 31),
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.orderNum);
              this.orderMoney.push(v.orderPrice);
            });
            if (this.tableActive === 1) {
              this.statTable = res.data;
              this.lebel1 = "消费订单笔数";
              this.lebel2 = "消费订单金额";
            }
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 时间查订单-table
    aboutMoreOrderTable() {
      this.$api.home
        .forTime({
          companyId: this.form.guishu ? this.form.guishu : null,
          startDay: this.moreStartTime,
          endDay: this.moreEndTime
            ? this.moreEndTime
            : this.calculateFutureDate(this.moreStartTime, 31),
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.statTable = res.data;
            this.lebel1 = "消费订单笔数";
            this.lebel2 = "消费订单金额";
          }
        });
    },

    // 时间查充值
    aboutMoreTop() {
      this.$api.home
        .forTime({
          companyId: this.form.guishu ? this.form.guishu : null,
          startDay: this.moreStartTime,
          endDay: this.moreEndTime
            ? this.moreEndTime
            : this.calculateFutureDate(this.moreStartTime, 31),
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.rechargeNum);
              this.orderMoney.push(
                (v.rechargeGive + v.rechargeReal).toFixed(2)
              );
            });

            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 时间查充值-表格
    aboutMoreTopTable() {
      this.$api.home
        .forTime({
          companyId: this.form.guishu ? this.form.guishu : null,
          startDay: this.moreStartTime,
          endDay: this.moreEndTime
            ? this.moreEndTime
            : this.calculateFutureDate(this.moreStartTime, 31),
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            res.data.forEach((v) => {
              v.all = (v.rechargeGive + v.rechargeReal).toFixed(2);
            });
            this.statTableTop = res.data;
          }
        });
    },

    // 更多日期换算

    calculateFutureDate(inputDate, days) {
      const date = new Date(inputDate);
      const currentDate = new Date(); // 获取当前日期

      // 如果输入日期到当前日期的天数小于31，则返回当前日期
      if (Math.floor((currentDate - date) / (1000 * 60 * 60 * 24)) < days) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      date.setDate(date.getDate() + days);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    getTypeList() {
      this.$api.shebei.typeArr().then((res) => {
        if (res.code === 200) {
          this.typeListArr = res.data;
        }
      });
    },
    equipemntDetail() {
      this.equipmentVisible = true;
      this.exportForm = {
        startTime: "",
        endTime: "",
      };
      this.shebeiChaForm = {
        model: "",
        num: "",
        typeName: "",
        startTime: "",
        endTime: "",
        address: "",
      };
      this.getEquipmentList();
    },
    equipmentExportBtn() {
      if (!this.exportForm.startTime || !this.exportForm.endTime) {
        handleAlert("请选择时间范围", "warning");
        return;
      }
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.shebei
            .shebeiExport({
              startTime: this.exportForm.startTime,
              endTime: this.exportForm.endTime,
            })
            .then((res) => {
              handleAlert("导出成功", "success");
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute("download", "设备列表.xls");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    reset() {
      this.shebeiChaForm = {
        model: "",
        num: "",
        typeName: "",
        startTime: "",
        endTime: "",
        address: "",
      };
      this.getEquipmentList();
    },
    getEquipmentList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .wlxsList({
          pageNum: this.page,
          pageSize: this.pageSize,
          futureEquipmentVersionId: this.shebeiChaForm.model,
          equipmentNum: this.shebeiChaForm.num,
          type: this.shebeiChaForm.typeName,
          startTime: this.shebeiChaForm.startTime,
          endTime: this.shebeiChaForm.endTime,
          equipmentPlace: this.shebeiChaForm.address,
        })
        .then((res) => {
          if (res.code === 200) {
            this.equipmentTableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    monthChange(e) {
      this.getMonth();
    },

    yearChange(e) {
      this.getYear();
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEquipmentList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getEquipmentList(this.page);
    },
    handleYieldDetail() {
      this.yieldStatTime_month = new Date().toISOString().slice(0, 7);
      this.yieldStatTime_year = new Date().getFullYear().toString();
      this.yieldSelectActive = 1;
      this.getMonth();
      this.yieldVisible = true;
    },
    yieledSelectBtn(v) {
      this.yieldSelectActive = v.id;
      if (this.yieldSelectActive == 1) {
        this.getMonth();
      } else {
        this.getYear();
      }
    },
    clearSelect() {
      this.getOrder();
      this.getChange();
      this.getshabei();
      // this.waterCard();
      this.getCardNum();
    },
    changeSelect() {
      this.getOrder();
      this.getChange();
      this.getshabei();
      // this.waterCard();
      this.getCardNum();
    },
    getGuishu() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        this.guishuqiye = res.data;
        // this.guishuqiye.unshift({ companyName: "运营平台", id: 0 });
      });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },

    getMonth() {
      this.$api.home
        .monthStat({
          companyId: this.form.guishu ? this.form.guishu : null,
          month: this.yieldStatTime_month,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.yieldStat = 0;
            this.tableData = res.data;
            this.tableData.forEach((v) => {
              v.allMoney = Number(v.wxPrice) + Number(v.rechargeReal);
              this.yieldStat += v.allMoney;
            });
          }
        });
    },

    // 水卡统计
    getCardNum() {
      let companyId = null;
      var token = store.getters.get_token;
      if (token) {
        companyId = token.companyId;
      }
      this.$api.home
        .mainCardDetail({
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.cardDetail = res.data;
            this.userForm = res.data;
          }
        });
    },

    getYear() {
      this.$api.home
        .yearStat({
          companyId: this.form.guishu ? this.form.guishu : null,
          year: this.yieldStatTime_year,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.yieldStat = 0;

            this.tableData = res.data;
            this.tableData.forEach((v) => {
              v.day = v.month;
              v.allMoney = Number(v.wxPrice) + Number(v.rechargeReal);
              let money = "";
              this.yieldStat += v.allMoney;
            });
          }
        });
    },

    // 水卡统计
    waterCard() {
      this.$api.home
        .waterCard({ companyId: this.form.guishu ? this.form.guishu : 0 })
        .then((res) => {
          if (res.code === 200) {
            this.userForm = res.data;
          }
        });
    },
    // 订单统计
    getOrder() {
      this.$api.home
        .orderStatistics({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          console.log(res, "订单统计");
          if (res.code === 200) {
            this.orderForm = res.data;
          }
        });
    },
    // 客户统计
    // getUser() {
    //   this.$api.home.userStatistics().then((res) => {
    //     if (res.code === 200) {
    //       this.userForm = res.data;
    //     }
    //   });
    // },
    // 设备统计
    getshabei() {
      this.$api.home
        .shebeiStatistics({
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.shebeiForm = res.data;
          }
        });
    },
    getEcharts() {
      this.myChart = echarts.init(document.querySelector("#main"), chartTheme());
      this.myChart.clear();
      this.myChart.setOption({
        title: {},
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["订单笔数（笔）", "订单金额（元）"],
          data: this.titleName,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: this.date,
          axisLabel: {
            margin: 20,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            margin: 20,
          },
        },
        series: [
          {
            name: this.numName,
            type: "line",
            stack: "Total",
            smooth: true,
            itemStyle: {
              normal: {
                color: "blue", //改变折线点的颜色
                lineStyle: {
                  color: "blue", //改变折线颜色
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: "#c5d0e4",
            },
            // data: [120, 132, 101, 134, 90, 230, 210],
            data: this.orderNum,
          },
          {
            name: this.moneyName,
            type: "line",
            stack: "Total",
            smooth: true,
            itemStyle: {
              normal: {
                color: "green", //改变折线点的颜色
                lineStyle: {
                  color: "green", //改变折线颜色
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: "#bcd4e7",
            },
            // data: [220, 182, 191, 234, 290, 330, 310],
            data: this.orderMoney,
          },
        ],
      });
      // 窗口缩放由 mounted 里的 ResizeObserver 统一处理（原 window.onresize 中 this 指向 window 是坏的）
    },

    // 七日订单数据
    aboutSevenOrder() {
      this.$api.home
        .aboutSevenOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          console.log(res, "七日数据");
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.orderNum);
              this.orderMoney.push(v.orderPrice);
            });
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 七日订单数据-表格
    aboutSevenOrderTable() {
      this.$api.home
        .aboutSevenOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.statTable = res.data;
            this.lebel1 = "消费订单笔数";
            this.lebel2 = "消费订单金额";
          }
        });
    },

    // 30日订单数据
    aboutMonthOrder() {
      this.$api.home
        .aboutMonthOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.orderNum);
              this.orderMoney.push(v.orderPrice);
            });
            if (this.tableActive === 1) {
              this.statTable = res.data;
              this.lebel1 = "消费订单笔数";
              this.lebel2 = "消费订单金额";
            }
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 30日订单数据-表格
    aboutMonthOrderTable() {
      this.$api.home
        .aboutMonthOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.statTable = res.data;
            this.lebel1 = "消费订单笔数";
            this.lebel2 = "消费订单金额";
          }
        });
    },

    // 七日充值数据
    aboutSevenTop() {
      this.$api.home
        .aboutSevenOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.rechargeNum);
              this.orderMoney.push(
                (v.rechargeGive + v.rechargeReal).toFixed(2)
              );
            });

            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 七日充值数据-表格
    aboutSevenTopTable() {
      this.$api.home
        .aboutSevenOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res, "近七日充值");
            res.data.forEach((v) => {
              v.all = (v.rechargeGive + v.rechargeReal).toFixed(2);
            });
            this.statTableTop = res.data;
            console.log(this.statTableTop, "this.statTableTop");
          }
        });
    },

    // 30日充值数据
    aboutMonthTop() {
      this.$api.home
        .aboutMonthOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          console.log(res, "30充值");
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              this.orderNum.push(v.rechargeNum);
              this.orderMoney.push(
                (v.rechargeGive + v.rechargeReal).toFixed(2)
              );
            });
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 30日充值数据-表格
    aboutMonthTopTable() {
      this.$api.home
        .aboutMonthOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            res.data.forEach((v) => {
              v.all = (v.rechargeGive + v.rechargeReal).toFixed(2);
            });
            this.statTableTop = res.data;
          }
        });
    },

    // 七日收益
    aboutSevenMoney() {
      this.$api.home
        .aboutSevenOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              // this.orderNum.push(v.rechargeNum);
              this.orderMoney.push((v.wxPrice + v.rechargeReal).toFixed(2));
            });
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // 30日收益
    aboutMonthMoney() {
      this.$api.home
        .aboutMonthOrder({
          companyId: this.form.guishu ? this.form.guishu : null,
          serverId: this.form.fuwu ? this.form.fuwu : 0,
          sceneId: this.form.scene ? this.form.scene : 0,
        })
        .then((res) => {
          if (res.code === 200) {
            this.date = [];
            this.orderNum = [];
            this.orderMoney = [];
            res.data.forEach((v) => {
              this.date.push(v.day);
              // this.orderNum.push(v.rechargeNum);
              this.orderMoney.push((v.wxPrice + v.rechargeReal).toFixed(2));
            });
            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    // typeChange(v) {
    //   this.typeActive = v.id;
    //   if (this.typeActive == 2 && this.dateActive == 1) {
    //     this.titleName = ["充值笔数（笔）", "充值金额（元）"];
    //     this.numName = "充值笔数（笔）";
    //     this.moneyName = "充值金额（元）";
    //     this.aboutSevenTop();
    //   } else if (this.typeActive == 2 && this.dateActive == 2) {
    //     this.titleName = ["充值笔数（笔）", "充值金额（元）"];
    //     this.numName = "充值笔数（笔）";
    //     this.moneyName = "充值金额（元）";
    //     this.aboutMonthTop();
    //   } else if (this.typeActive == 1 && this.dateActive == 1) {
    //     this.titleName = ["订单笔数（笔）", "订单金额（元）"];
    //     this.numName = "订单笔数（笔）";
    //     this.moneyName = "订单金额（元）";
    //     this.aboutSevenOrder();
    //   } else if (this.typeActive == 1 && this.dateActive == 2) {
    //     this.titleName = ["订单笔数（笔）", "订单金额（元）"];
    //     this.numName = "订单笔数（笔）";
    //     this.moneyName = "订单金额（元）";
    //     this.aboutMonthOrder();
    //   } else if (this.typeActive == 3 && this.dateActive == 1) {
    //     this.titleName = ["收益金额（元）"];
    //     // this.numName = "订单笔数（笔）";
    //     this.moneyName = "收益金额（元）";
    //     this.aboutSevenMoney();
    //   } else {
    //     this.titleName = ["收益金额（元）"];
    //     // this.numName = "订单笔数（笔）";
    //     this.moneyName = "收益金额（元）";
    //     this.aboutMonthMoney();
    //   }
    // },

    typeChange(v) {
      this.typeActive = v.id;
      if (
        this.typeActive == 2 &&
        this.dateActive == 1 &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutSevenTop();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 2 &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutMonthTop();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 1 &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutSevenOrder();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 2 &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutMonthOrder();
      }
      // else if (this.typeActive == 3 && this.dateActive == 1) {
      //   this.titleName = ["收益金额（元）"];
      //   // this.numName = "订单笔数（笔）";
      //   this.moneyName = "收益金额（元）";
      //   this.aboutSevenMoney();
      // }
      else if (
        this.typeActive == 1 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 1
      ) {
        this.titleName = ["消费订单（笔）", "消费金额（元）"];
        this.numName = "消费订单（笔）";
        this.moneyName = "消费金额（元）";
        this.aboutMoreOrder();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 1
      ) {
        this.titleName = ["充值订单（笔）", "充值金额（元）"];
        this.numName = "充值订单（笔）";
        this.moneyName = "充值金额（元）";
        this.aboutMoreTop();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenTopTable();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutMonthTopTable();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenOrderTable();
      } else if (
        this.typeActive == 1 &&
        this.dateActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutMonthOrderTable();
      }
      // else if (this.typeActive == 3 && this.dateActive == 1) {
      //   this.titleName = ["收益金额（元）"];
      //   // this.numName = "订单笔数（笔）";
      //   this.moneyName = "收益金额（元）";
      //   this.aboutSevenMoney();
      // }
      else if (
        this.typeActive == 1 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 2
      ) {
        this.aboutMoreOrderTable();
      } else if (
        this.typeActive == 2 &&
        this.dateActive == 3 &&
        this.moreName !== "更多" &&
        this.tableActive == 2
      ) {
        this.aboutMoreTopTable();
      }

      // else {
      //   this.titleName = ["收益金额（元）"];
      //   // this.numName = "订单笔数（笔）";
      //   this.moneyName = "收益金额（元）";
      //   this.aboutMonthMoney();
      // }
    },

    dateChange(v) {
      this.dateActive = v.id;
      if (
        this.dateActive == 2 &&
        this.typeActive == 1 &&
        this.tableActive == 1
      ) {
        this.aboutMonthOrder();
      } else if (
        this.dateActive == 2 &&
        this.typeActive == 2 &&
        this.tableActive == 1
      ) {
        this.aboutMonthTop();
      } else if (
        this.dateActive == 1 &&
        this.typeActive == 1 &&
        this.tableActive == 1
      ) {
        this.aboutSevenOrder();
      } else if (
        this.dateActive == 1 &&
        this.typeActive == 2 &&
        this.tableActive == 1
      ) {
        this.aboutSevenTop();
      } else if (
        this.dateActive == 2 &&
        this.typeActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutMonthOrderTable();
      } else if (
        this.dateActive == 2 &&
        this.typeActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutMonthTopTable();
      } else if (
        this.dateActive == 1 &&
        this.typeActive == 1 &&
        this.tableActive == 2
      ) {
        this.aboutSevenOrderTable();
      } else if (
        this.dateActive == 1 &&
        this.typeActive == 2 &&
        this.tableActive == 2
      ) {
        this.aboutSevenTopTable();
      }

      // else if (this.typeActive == 3 && this.dateActive == 1) {
      //   this.aboutSevenMoney();
      // } else {
      //   this.aboutMonthMoney();
      // }
    },

    getChange() {
      if (this.dateActive == 2 && this.typeActive == 1) {
        this.aboutMonthOrder();
      } else if (this.dateActive == 2 && this.typeActive == 2) {
        this.aboutMonthTop();
      } else if (this.dateActive == 1 && this.typeActive == 1) {
        this.aboutSevenOrder();
      } else if (this.dateActive == 1 && this.typeActive == 2) {
        this.aboutSevenTop();
      } else if (this.typeActive == 3 && this.dateActive == 1) {
        this.aboutSevenMoney();
      } else {
        this.aboutMonthMoney();
      }
    },

    //表格序号，根据索引+1
    // indexMethod(index) {
    //   return index + 1;
    // },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    // handleSizeChange(val) {
    //   console.log(val);
    // },
    // 当前页面,当前页面改变时触发事件
    // handleCurrentChange(val) {
    //   console.log(val);
    // },
    // // 根据条件判断字段颜色
    // cellStayle(row, colum, rowIndex, columnIndex) {
    //   if (row.row.state === "已处理" && row.columnIndex == 6) {
    //     return "color:green";
    //   } else if (row.row.state === "待处理" && row.columnIndex == 6) {
    //     return "color:red";
    //   } else {
    //     return;
    //   }
    // },
  },
  // 销毁组件前清除挂载在window上的事件
  beforeDestroy() {
    window.onresize = null;
    if (this._chartRO) this._chartRO.disconnect();
    if (this._resizeChart) window.removeEventListener("resize", this._resizeChart);
    if (this._onThemeChange) window.removeEventListener("themechange", this._onThemeChange);
  },
};
</script>

<style scoped lang="scss">
.roledLook {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
  .stat {
    width: 40%;
    height: 500px;
    background: var(--card-bg);
    box-shadow: 2px 6px 5px 4px rgba(0, 0, 0, 0.2);
    padding: 15px 40px !important;
    box-sizing: border-box;
    border-radius: 20px;

    // .statNum {
    //   position: relative;
    //   width: 100%;
    //   top: 50%;
    //   transform: translateY(-70%);
    // }
    // margin-right: 50px;
  }
}
.statistical-data {
  .statistics {
    /* 参照平台：等宽网格 + gap（原 flex + 固定 20% 宽 + margin） */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 18px;
    margin-bottom: 22px;
    /* ===== 完整 stat-card 卡片（参照平台：圆形图标 + 彩色数值 + 底部详情）===== */
    .box {
      position: relative;
      min-height: 270px;
      padding: 24px 22px 16px !important;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      overflow: hidden;
      background: var(--card-bg);
      border: 1px solid var(--card-border);
      border-radius: var(--card-radius);
      box-shadow: var(--card-shadow);
      transition: transform 0.18s ease, box-shadow 0.18s ease,
        border-color 0.18s ease;
      /* 底部径向辉光（夜间发光、白天几乎不可见） */
      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 96px;
        background: radial-gradient(
          120% 100% at 50% 150%,
          rgba(56, 182, 255, 0.28) 0%,
          rgba(56, 182, 255, 0) 72%
        );
        pointer-events: none;
      }
      &:hover {
        transform: translateY(-3px);
        border-color: rgba(64, 190, 255, 0.72);
        box-shadow: 0 0 30px rgba(30, 130, 230, 0.4),
          inset 0 1px 0 rgba(130, 195, 255, 0.2);
      }
      .cardHint {
        z-index: 1;
        margin-top: 12px;
        color: var(--text-muted);
        font-size: 12px;
        line-height: 1.4;
        text-align: center;
      }

      /* 头部：标题 + 大数值（左） / 圆形图标（右上） */
      .stat-card-header {
        position: relative;
        z-index: 1;
        min-height: 92px;
      }
      .stat-card-title {
        margin-top: 4px;
        padding-right: 66px;
        color: var(--text-main);
        font-size: 16px;
        font-weight: 600;
      }
      .stat-card-value {
        margin-top: 18px;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
        white-space: nowrap;
        text-shadow: var(--stat-glow);
      }
      .stat-card-icon {
        position: absolute;
        top: 0;
        right: 0;
        width: 52px;
        height: 52px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        background: var(--card-bg);
        border: 1px solid currentColor;
        box-shadow: var(--glow);
      }
      /* 明细行 */
      .stat-card-body {
        position: relative;
        z-index: 1;
        margin-top: 16px;
      }
      .stat-card-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 32px;
        color: var(--text-sub);
        font-size: 15px;
      }
      .stat-card-row span {
        color: var(--brand);
        font-weight: 700;
        text-align: right;
        white-space: nowrap;
        font-variant-numeric: tabular-nums;
      }
      /* 六类语义色（数值 + 图标同色） */
      &.equipment-card .stat-card-value,
      &.equipment-card .stat-card-icon {
        color: var(--stat-cyan);
      }
      &.card-card .stat-card-value,
      &.card-card .stat-card-icon {
        color: var(--stat-blue);
      }
      &.recharge-card .stat-card-value,
      &.recharge-card .stat-card-icon {
        color: var(--stat-purple);
      }
      &.order-card .stat-card-value,
      &.order-card .stat-card-icon {
        color: var(--stat-green);
      }
      &.consume-card .stat-card-value,
      &.consume-card .stat-card-icon {
        color: var(--stat-orange);
      }
      /* 详情按钮：沉底居中胶囊（参照平台） */
      .detailsBtn {
        position: relative;
        z-index: 1;
        align-self: center;
        min-width: 76px;
        height: 34px;
        padding: 0 20px;
        margin-top: auto;
        color: var(--accent);
        background: var(--input-bg);
        border: 1px solid var(--accent);
        border-radius: 17px;
        transition: all 0.2s ease;
      }
      .detailsBtn:hover,
      .detailsBtn:focus {
        color: #fff;
        background: var(--brand-grad);
        border-color: transparent;
        box-shadow: var(--btn-shadow);
      }
    }
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
/* 趋势分析（折线图）容器：卡片化（参照平台 #main） */
#main {
  width: 100%;
  height: 420px;
  margin-top: 12px;
  padding: 10px 16px 4px;
  box-sizing: border-box;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--card-radius);
  box-shadow: var(--card-shadow);
}
/* 列表分析（趋势表格）容器：与图表同款卡片面板，el-table 由全局皮肤透明透出 + 随日夜 */
.trend-panel {
  padding: 12px 16px;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--card-radius);
  box-shadow: var(--card-shadow);
  box-sizing: border-box;
  ::v-deep .el-table {
    background: transparent;
    border-radius: 8px;
  }
}
/* 类型 / 日期 / 列表 三组切换：分段控件（segmented control）
   —— 一个圆角容器把选项连成一体、选中项内嵌高亮，取代原来每项独立胶囊，
   避免「下面全是胶囊」的臃肿感。纯样式，模板类名 .type/.date/.table(+Active) 不变。 */
.typeSelect,
.dateSelect,
.tableSelect {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 10px;
  box-sizing: border-box;
  vertical-align: middle;
}
.tableSelect {
  margin-bottom: 14px;
}
.typeSelect {
  margin: 4px 0 12px;
}
/* 单个分段（未选中）：透明底、无边框、小圆角 */
.typeSelect .type,
.dateSelect .date,
.tableSelect .table {
  min-width: 66px;
  height: 30px;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
  color: var(--text-sub);
  background: transparent;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;
}
.typeSelect .type:hover,
.dateSelect .date:hover,
.tableSelect .table:hover {
  color: var(--accent);
}
/* 选中分段：内嵌高亮块（只有当前项有底色，整体更轻） */
.typeSelect .typeActive,
.dateSelect .dateActive,
.tableSelect .tableActive {
  min-width: 66px;
  height: 30px;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
  color: #fff;
  background: var(--brand-grad);
  border: none;
  border-radius: 7px;
  box-shadow: 0 1px 5px rgba(12, 113, 207, 0.28);
  cursor: pointer;
}

.littleText {
  font-size: 16px;
}

.el-select {
  width: 200px !important;
}

/* .isHaveDetail 已随 stat-card 结构移除；.detailsBtn 现由上方 .box 内规则统一（底部居中胶囊） */

/deep/ .el-descriptions__header {
  margin-bottom: 8px !important;
  margin-top: 8px !important;
  font-size: 12px !important;
  color: var(--accent);
  text-decoration: underline;
}

.yieldTop {
  display: flex;
  justify-content: space-between;
  .select {
    padding: 6px 16px;
    border: 1px solid var(--input-border);
    border-radius: 16px;
    margin-right: 10px;
    cursor: pointer;
    box-sizing: border-box;
    color: var(--text-sub);
    background: var(--input-bg);
    transition: all 0.2s ease;
  }
  .select:hover {
    color: var(--accent);
    border-color: var(--accent);
  }
  .selectActive {
    padding: 6px 16px;
    border: 1px solid transparent;
    border-radius: 16px;
    margin-right: 10px;
    cursor: pointer;
    box-sizing: border-box;
    color: #fff;
    background: var(--brand-grad);
    box-shadow: var(--btn-shadow);
  }
}

.el-date-editor {
  width: 80% !important;
}

.yieldTable {
  height: 300px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
